module.exports = __webpack_public_path__ + "img/welcome-migrate-system.2914143f.svg";